import Video from "./video";
export default class Agent {
  static lower() {
    return navigator.userAgent.toLowerCase();
  }

  static isMobile() {
    return this.lower().indexOf("mobile") >= 0 || this.isXiaomi();
  }

  static isIphone() {
    return this.lower().indexOf("iphone") >= 0;
  }

  static isXiaomi() {
    return this.lower().indexOf("xiaomi/miui") >= 0;
  }

  static isHuawei() {
    return this.lower().indexOf("honor") >= 0;
  }

  static isDesktop() {
    return !this.isMobile();
  }
  static isMac() {
    const ua = navigator.userAgent.toLowerCase();
    return /macintosh|mac os x/i.test(ua);
  }
  static isAndroid() {
    const u = navigator.userAgent;
    //android终端
    return u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
  }

  static isQQinstalled() {
    return (
      !this.isWeiXin() &&
      this.lower().indexOf(" qqtheme") > -1 &&
      this.lower().indexOf("mqqbrowser") > -1
    );
  }
  static isQQBrowser() {
    const ua = this.lower();
    return (
      !this.isWeiXin() &&
      (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) &&
      ua.indexOf(" qq") < 0
    );
  }
  static isWeiXin() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.match(/micromessenger/) != null;
  }

  static isSupport(): boolean {
    if (!Video.checkSupport()) return false;
    // 禁用安卓 + 手机百度APP
    if (Agent.lower().indexOf("baiduboxapp") > 0 && Agent.isAndroid()) {
      return false;
    }
    // 禁用安卓 + 手机百度浏览器
    if (Agent.lower().indexOf("flyflow") > 0 && Agent.isAndroid()) {
      return false;
    }
    // 禁用安卓 + 手机QQ
    if (Agent.isAndroid() && Agent.isQQinstalled()) {
      return false;
    }
    // 禁用三星S8 + 手机QQ浏览器
    if (Agent.lower().indexOf("sm-g9550") > 0 && Agent.isQQBrowser()) {
      return false;
    }
    // 禁用红米8A + 猎豹浏览器
    if (
      Agent.lower().indexOf("redmi") > 0 &&
      Agent.lower().indexOf("liebaofast") > 0
    ) {
      return false;
    }
    // 禁用红米8A + 欧朋浏览器
    if (
      Agent.lower().indexOf("redmi") > 0 &&
      Agent.lower().indexOf("opr") > 0
    ) {
      return false;
    }
    // 禁用红米8A + 夸克浏览器
    if (
      Agent.lower().indexOf("redmi") > 0 &&
      Agent.lower().indexOf("quark") > 0
    ) {
      return false;
    }
    return true;
  }
}
